import InsuranceForm from "../../components/insurance/InsuranceForm";

export default function InsurancePage() {
  return (
    <div className="InsurancePage">
      <InsuranceForm />
    </div>
  );
}
